import {
  PayloadAction,
  createSlice,
  createListenerMiddleware,
} from "@reduxjs/toolkit"
import { PURGE } from "redux-persist"
import { RosterItem } from "../api/xmppApi"
import { refreshVCards } from "./rosterThunks"

export type Roster = {
  items: RosterItem[]
}

const initialState: Roster = {
  items: [],
}

const roster = createSlice({
  name: "roster",
  initialState,
  reducers: {
    setRoster: (state: Roster, action: PayloadAction<Roster>) => {
      state.items = action.payload.items
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const { setRoster } = roster.actions

export const rosterUpdateListener = createListenerMiddleware()

rosterUpdateListener.startListening({
  actionCreator: setRoster,
  effect: refreshVCards,
})

export default roster.reducer
